module.exports = __webpack_public_path__ + "../resources/img/ic_ac_combiner.9d9c4c4e.svg";